import axios from 'axios';

export default {
  async LOAD_jobs({ commit }) {
    const result = await axios.get('api/jobs');
    commit('SET_jobs', result.data);
    return result.data;
  },
};
